import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import PricingCards from "@/components/PricingCards";
import { LockKeyOpen } from "@phosphor-icons/react";

export default function UpgradeModal({ open, onOpenChange, returnTo, reason }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-border max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="upgrade-modal">
        <DialogHeader>
          <div className="w-11 h-11 rounded-lg bg-accent/12 border border-accent/25 flex items-center justify-center mb-2">
            <LockKeyOpen size={22} weight="duotone" className="text-accent" />
          </div>
          <DialogTitle className="font-display text-2xl">Abonnez-vous à interKO</DialogTitle>
          <DialogDescription className="text-muted">
            {reason || "Pour 29 €/mois, sans engagement, accédez sans limite aux opportunités de mission, aux décideurs et à leurs coordonnées."}
          </DialogDescription>
        </DialogHeader>
        <div className="py-2">
          <PricingCards returnTo={returnTo} />
        </div>
        <p className="text-xs text-muted text-center pt-1">Paiement mensuel sécurisé par Stripe · Résiliable à tout moment</p>
      </DialogContent>
    </Dialog>
  );
}
